import { Box, Chip, Stack, Typography } from '@mui/material';
import ToolTip from '../../ToolTip/ToolTip';

/**
 * SkillX referral leads — grid columns.
 *
 * The column that justifies this screen existing is "Referred By". Everything
 * else the sales team can already see on the DEO leads grid; what they cannot
 * see there is which learner sent the lead in, which is the whole reason a
 * referral is worth calling first.
 */

/** Sales-facing status colours. Keys match the API's `status`. */
const STATUS_STYLE = {
  SUBMITTED: { label: 'New', color: '#9A6B00', bg: '#FFF3D6' },
  CONTACTED: { label: 'In progress', color: '#2E75BC', bg: '#E1EDFA' },
  ENROLLED: { label: 'Admitted', color: '#1E7E4F', bg: '#DEF3E7' },
  CLOSED: { label: 'Closed', color: '#7A8699', bg: '#EDF0F5' },
};

const fmtDate = (value) => {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const skillxReferralLeadsTableHead = [
  { field: 'sl_no', headerName: 'Sl No', width: 80 },
  { field: 'lead_name', headerName: 'Referred Student', width: 200 },
  { field: 'contact', headerName: 'Contact', width: 160 },
  { field: 'lead_email_id', headerName: 'Email', width: 200 },
  { field: 'lead_place', headerName: 'Place', width: 140 },
  {
    field: 'preferred_course',
    headerName: 'Interested In',
    width: 160,
    renderCell: ({ value }) =>
      value || <Typography sx={{ fontSize: 13, color: 'text.disabled' }}>—</Typography>,
  },
  {
    // The point of the screen: who sent this lead in, and their admission
    // number so the counsellor can look the referrer up if they need to.
    field: 'referrer_name',
    headerName: 'Referred By',
    width: 220,
    renderCell: ({ row }) => (
      <Stack spacing={0.2} sx={{ py: 0.5 }}>
        <Typography sx={{ fontSize: 13.5, fontWeight: 600, lineHeight: 1.3 }}>
          {row.referrer_name || 'Unknown student'}
        </Typography>
        <Typography sx={{ fontSize: 11.5, color: 'text.secondary', lineHeight: 1.3 }}>
          Adm no. {row.referrer_admn_no}
        </Typography>
      </Stack>
    ),
  },
  { field: 'assigned_to', headerName: 'Assigned To', width: 180 },
  {
    field: 'status',
    headerName: 'Status',
    width: 140,
    renderCell: ({ value }) => {
      const style = STATUS_STYLE[value] || STATUS_STYLE.SUBMITTED;
      return (
        <Chip
          size="small"
          label={style.label}
          sx={{
            fontWeight: 700,
            fontSize: 12,
            color: style.color,
            bgcolor: style.bg,
          }}
        />
      );
    },
  },
  {
    field: 'lead_timestamp',
    headerName: 'Referred On',
    width: 140,
    renderCell: ({ value }) => fmtDate(value),
  },
  {
    field: 'enrolled_at',
    headerName: 'Admitted On',
    width: 140,
    renderCell: ({ value }) =>
      value ? (
        fmtDate(value)
      ) : (
        <Typography sx={{ fontSize: 13, color: 'text.disabled' }}>—</Typography>
      ),
  },
  {
    field: 'lead_remarks',
    headerName: 'Remarks',
    width: 260,
    renderCell: (params) => (
      <Box>
        <ToolTip expand={params.row.lead_remarks} content={params.row.lead_remarks} />
      </Box>
    ),
  },
];
